// src/pages/dashboard/Inscripciones/components/Paso2_Inscripcion.jsx
import React, { useEffect } from 'react';
import { Form, Select, Input, DatePicker, Button, message } from 'antd';
import moment from 'moment';
import apiClient from '../../../../api/apiClient';

const { Option } = Select;

const Paso2_Inscripcion = ({ state, dispatch }) => {
  const { alumno, inscripcion, catalogos } = state;

  // FECHA DE HOY
  useEffect(() => {
    if (!inscripcion.FechaInscripcion) {
      dispatch({
        type: 'UPDATE_INSCRIPCION',
        payload: { FechaInscripcion: moment().format('YYYY-MM-DD') },
      });
    }
  }, [inscripcion.FechaInscripcion, dispatch]);

  useEffect(() => {
  }, [catalogos.grados]);

  // CARGAR COSTO E INSCRIPCIÓN AUTOMÁTICOS
  const handleGradoChange = async (idGrado) => {
    dispatch({ type: 'UPDATE_INSCRIPCION', payload: { IdGrado: idGrado } });

    if (!idGrado) return;

    try {
      const res = await apiClient.get(`/grados/costo/${encodeURIComponent(idGrado)}`);
      if (res.data.success && res.data.data) {
        const { ValorInscripcion, Mensualidad } = res.data.data;

        dispatch({
          type: 'UPDATE_INSCRIPCION',
          payload: {
            ValorInscripcion: parseFloat(ValorInscripcion) || 0,
            Mensualidad: parseFloat(Mensualidad) || 0,
          }
        });
      }
    } catch (error) {
      message.error('Error al cargar costos');
    }
  };

  // GUARDAR SELECCIÓN DE GRADO Y CARGAR COSTO
  const onGradoSelect = (IdGrado) => {
    // 1. Guardar IdGrado en el state
    dispatch({
      type: 'UPDATE_INSCRIPCION',
      payload: { IdGrado },
    });

    // 2. Cargar costo
    handleGradoChange(IdGrado);
  };

  const handleNext = () => {
    if (!inscripcion.IdGrado || !inscripcion.IdSeccion || !inscripcion.IdJornada) {
      message.error('Seleccione grado, sección y jornada');
      return;
    }

    dispatch({ type: 'NEXT_STEP' });
  };

  return (
    <Form layout="vertical">
      {/* ALUMNO */}
      <Form.Item label="Alumno">
        <Input
          value={`${alumno.Nombres} ${alumno.Apellidos}`}
          readOnly
          style={{ color: '#003366', fontWeight: 'bold' }}
        />
      </Form.Item>

      {/* CARNET */}
      <Form.Item label="Carnet">
        <Input
          value={
            state.modo === 'reinscribir'
              ? (state.alumno.IdAlumno || 'No encontrado')
              : (state.siguienteCarnet || 'Cargando...')
          }
          readOnly
          style={{
            color: state.modo === 'reinscribir' ? '#003366' : '#d4380d',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        />
      </Form.Item>

      {/* GRADO */}
     <Form.Item label="Grado" required>
      <Select
        key={catalogos.grados.map(g => g.IdGrado).join('-')} // ← CLAVE
        placeholder="Seleccione grado"
        value={inscripcion.IdGrado}
        onChange={onGradoSelect}
        showSearch
        optionFilterProp="children"
        loading={catalogos.grados.length === 0}
      >
        {catalogos.grados.length === 0 ? (
          <Option disabled>Cargando grados...</Option>
        ) : (
          catalogos.grados.map(g => (
            <Option key={g.IdGrado} value={g.IdGrado}>
              {g.NombreGrado}
            </Option>
          ))
        )}
      </Select>
    </Form.Item>

      {/* SECCIÓN */}
      <Form.Item label="Sección" required>
        <Select
          placeholder="Seleccione sección"
          value={inscripcion.IdSeccion}
          onChange={(value) =>
            dispatch({ type: 'UPDATE_INSCRIPCION', payload: { IdSeccion: value } })
          }
        >
          {catalogos.secciones.map(s => (
            <Option key={s.IdSeccion} value={s.IdSeccion}>
              {s.NombreSeccion}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* JORNADA */}
      <Form.Item label="Jornada" required>
        <Select
          placeholder="Seleccione jornada"
          value={inscripcion.IdJornada}
          onChange={(value) =>
            dispatch({ type: 'UPDATE_INSCRIPCION', payload: { IdJornada: value } })
          }
        >
          {catalogos.jornadas.map(j => (
            <Option key={j.IdJornada} value={j.IdJornada}>
              {j.NombreJornada}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* FECHA INSCRIPCIÓN */}
      <Form.Item label="Fecha de Inscripción">
        <DatePicker
          style={{ width: '100%' }}
          value={inscripcion.FechaInscripcion ? moment(inscripcion.FechaInscripcion) : null}
          onChange={(date) =>
            dispatch({
              type: 'UPDATE_INSCRIPCION',
              payload: { FechaInscripcion: date?.format('YYYY-MM-DD') },
            })
          }
          format="DD/MM/YYYY"
        />
      </Form.Item>

      {/* MENSUALIDAD */}
      <Form.Item label="Mensualidad (Enero)">
        <Input
          value={`Q ${Number(inscripcion.Mensualidad || 0).toFixed(2)}`}
          readOnly
          style={{ color: '#d4380d', fontWeight: 'bold' }}
        />
      </Form.Item>

      {/* BOTÓN SIGUIENTE */}
      <Form.Item>
        <Button type="primary" size="large" onClick={handleNext} style={{ width: '100%' }}>
          Siguiente
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Paso2_Inscripcion;